import React, { useCallback, useState } from 'react';
import { useWindowSize } from 'react-use';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import Tooltip from 'components/generic/Tooltip.component';
import MOBILE_VIEWPORT from 'constants/ui/mobileViewport.const';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import call from 'utils/functions/call.util';

import CN from './Foldout.module.scss';

const RenderContent = ({ onToggle, src, title, isOpen, children, withIcon }) => {
  const { width: windowWidth } = useWindowSize();
  const isMobileViewport = windowWidth <= MOBILE_VIEWPORT;
  return (
    <div data-bem="RenderContent" className={CN.toggleButton}>
      <div data-bem="RenderContent__header" className={CN.header} role="button" tabIndex={0} onClick={onToggle}>
        <div data-bem="RenderContent__title" className={CN.title}>
          {fromAnyToBool(src) && <img src={src} alt="Icon for section" className={CN.icon} />} {title}
        </div>
        {withIcon ? (
          <Icon tag="Foldout__icon" variant="roundedPlusMinusPurple" selected={!isOpen} unselected={isOpen} width="lg" />
        ) : (
          <Icon tag="Foldout__arrow" variant="arrowFoldout" selected={!isOpen} unselected={isOpen} width={isMobileViewport ? 'xl' : 'l1'} />
        )}
      </div>
      {isOpen && <div data-bem="Foldout__children">{children}</div>}
    </div>
  );
};
const Foldout = ({ tag, title, src, children, isOpen: isOpenFromProps, onToggle, disabled, tooltipText, variant, withIcon, width }) => {
  const { isDarkMode } = useTheme();
  const [isOpen, setIsOpen] = useState(fromAnyToBool(isOpenFromProps));

  const handleToggle = useCallback(() => {
    if (disabled) return;

    const nextValue = !isOpen;
    setIsOpen(nextValue);
    call('Foldout.onToggle', onToggle, { isOpen: nextValue });
  }, [isOpen, onToggle, setIsOpen, disabled]);

  return (
    <div
      data-bem="Foldout"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
        [CN[`${variant}Variant`]]: variant,
        [CN[`${width}Width`]]: width,
        [CN.isOpen]: isOpen,
      })}
    >
      {disabled ? (
        <Tooltip variant="slickTop" width="md" content={tooltipText}>
          <RenderContent onToggle={handleToggle} src={src} title={title} isOpen={isOpen} children={children} />
        </Tooltip>
      ) : (
        <RenderContent onToggle={handleToggle} src={src} title={title} isOpen={isOpen} children={children} withIcon={withIcon} />
      )}
    </div>
  );
};

export default Foldout;
